var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer",style:(_vm.outerStyle)},[_c('div',{staticClass:"inner",style:(_vm.innerStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }